import { useMutation } from '@tanstack/react-query';
import { tasksRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useDisableTask = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    tasksRepo.disableTask(id),
  );
